import PropTypes from 'prop-types';
import React from 'react'
import createReactClass from 'create-react-class';

import { TextLoader } from '~/components/Loaders'

import {
	AddOtherNetwork,
	EmailAddress,
	Passwords
} from './components'


export default createReactClass({

	edited_fields: [],

	propTypes: {
		fetching: PropTypes.bool,
		user: PropTypes.object
	},

	editField: function(field) {
		this.edited_fields.push(field)
	},

	saveFields: function() {
		this.edited_fields.splice( this.edited_fields.indexOf('email'), 1 )
	},

	render: function() {

		return (
			<div className="panel mbot0 p20 mright10 mright0-xs mbot20-xs" id="settings-pane">

				<h3 className="mtop0 mbot20">Settings</h3>

				{this.props.fetching 
                	? <TextLoader />
                	: <div>
						<EmailAddress email={this.props.user.email} />
						<Passwords {...this.props.user} />
					</div>
				}

			</div>
		)

	}

})



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Body/components/Settings/index.jsx